import { Link, usePage } from '@inertiajs/react'
import Icon from '@/Shared/Icon'
import { Avatar } from '@material-tailwind/react'

export default function ({ users, id, canAdd = false }) {
  const {
    auth: { user }
  } = usePage().props

  return (
    <div>
      <div className="my-4 mt-8 flex justify-between">
        <h2 className="text-2xl font-bold">Designations</h2>

        {user.role === '1' && canAdd ? (
          <Link
            className="btn-indigo focus:outline-none"
            href={route('hr.user.create', id)}
          >
            <span>Add HR</span>
            <span className="hidden md:inline"> Designation</span>
          </Link>
        ) : null}
      </div>

      <div className="mt-6 overflow-x-auto rounded bg-white shadow">
        <table className="w-full whitespace-nowrap">
          <thead>
            <tr className="text-left font-bold">
              <th className="px-6 pb-4 pt-5">Sr No.</th>
              <th className="px-6 pb-4 pt-5">Name</th>
              <th className="px-6 pb-4 pt-5">CNIC</th>
              <th className="px-6 pb-4 pt-5">Contact</th>
              <th className="px-6 pb-4 pt-5">Designation</th>
              <th className="px-6 pb-4 pt-5">Avatar</th>
            </tr>
          </thead>

          <tbody>
            {users?.map(
              (
                { id, name, contact, cnic, designation, avatar, deleted_at },
                index
              ) => {
                return (
                  <tr
                    key={id}
                    className="focus-within:bg-gray-100 hover:bg-gray-100"
                  >
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.user.edit', id)}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {index + 1}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.user.edit', id)}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {name}
                        {deleted_at && (
                          <Icon
                            name="trash"
                            className="ml-2 h-3 w-3 flex-shrink-0 fill-current text-gray-400"
                          />
                        )}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        href={route('hr.user.edit', id)}
                        className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                      >
                        {cnic}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        href={route('hr.user.edit', id)}
                        className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                      >
                        {contact}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.user.edit', id)}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {designation}
                      </Link>
                    </td>
                    <td className="border-t pl-6">
                      <Avatar src={`${avatar}`} alt={name} size="sm" />
                    </td>
                    <td className="w-px border-t">
                      <Link
                        tabIndex="-1"
                        href={route('hr.user.edit', id)}
                        className="flex items-center px-4 focus:outline-none"
                      >
                        <Icon
                          name="cheveron-right"
                          className="block h-6 w-6 fill-current text-gray-400"
                        />
                      </Link>
                    </td>
                  </tr>
                )
              }
            )}
            {users?.length === 0 && (
              <tr>
                <td className="border-t px-6 py-4" colSpan="4">
                  No record found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
